import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

const faqItems = [
  {
    q: "What's included in the coaching?",
    a: "Weekly group coaching calls where we review what's working, troubleshoot problems, and share wins. Monthly 1-on-1s where we look at YOUR numbers and build YOUR gameplan. Plus a private community of other tree service owners who are scaling the same way you are. This isn't theory - it's field-tested tactics."
  },
  {
    q: "I don't have time for coaching calls - I'm in the field all day.",
    a: "That's exactly why you need this. The calls are recorded. The implementation is done FOR you. The systems run whether you're on a call or in a tree. But the accountability? That's what turns this from 'another thing I bought' into 'the system that changed my business.' 15 minutes a week beats years of spinning your wheels."
  },
  {
    q: "What if I don't need coaching - I just want the software?",
    a: "Then this probably isn't for you. The software is the easy part. The hard part is actually using it, following up consistently, and not falling back into old habits. That's what the coaching solves. If you just want software, there are cheaper options. But if you want to actually GROW? You need accountability."
  },
  {
    q: "I already use Jobber/JobNimbus. Does this replace them?",
    a: "We focus on the FRONT end—getting the leads and booking the jobs. We integrate with your existing software so your new leads flow directly into your workflow. We don't replace your 'hammer,' we just make sure you have more 'nails' to hit."
  },
  {
    q: "Will my customers like automated texts?",
    a: "In 2026, people want instant answers. When they message you and get an immediate, professional reply with a link to book an estimate, they stop calling the next guy. It makes you look like a million-dollar operation."
  }
];

const FAQ: React.FC = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-24 bg-[#0F1419]">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-16">
          <HelpCircle className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
          <h2 className="text-4xl md:text-6xl font-black mb-4 uppercase text-white italic tracking-tighter">Straight Talk</h2>
          <p className="text-[#059669] font-black uppercase tracking-widest">Field-tested answers from the guys in the trucks.</p>
        </div>
        <div className="space-y-4">
          {faqItems.map((item, idx) => (
            <div key={idx} className="border border-white/10 rounded-2xl overflow-hidden bg-white/5 backdrop-blur-sm transition-all hover:border-[#059669]/30">
              <button 
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full p-6 text-left flex justify-between items-center group transition-colors hover:bg-white/10"
              >
                <span className="text-xl font-bold pr-8 text-white">{item.q}</span>
                {openIdx === idx ? <ChevronUp className="w-6 h-6 text-[#FF6B35]" /> : <ChevronDown className="w-6 h-6 text-white/40" />}
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-6 text-gray-400 text-lg leading-relaxed animate-in fade-in slide-in-from-top-2 duration-300">
                  <div className="h-[1px] bg-white/10 mb-6" />
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;